import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Headline } from '@gaiads/telia-react-component-library';
import { getOrganizationOrdersReport } from '../../utils';
import { showGrowlNotification } from '../../store/actions';
import { downloadSpreadsheet } from '@cdaas/reusable-components-daas';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/reducers';

const OrganizationOrders: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('orders');

  const organizationName = useSelector((state: RootState) => state.authentication.user?.organization?.name);

  const handleDownloadReport = async (): Promise<void> => {
    const response = await getOrganizationOrdersReport();
    if (response === null) {
      dispatch(showGrowlNotification(t('organizationOrders.getOrganizationOrdersReportError'), 'error'));
    } else {
      const filePrefix = organizationName ? `${organizationName}-orders` : 'orders';
      await downloadSpreadsheet('Organization orders', response, filePrefix);
    }
  };

  return (
    <>
      <Headline size={'lg'} margin={{ vertical: 'xlg' }}>
        {t('organizationOrders.organizationOrdersTitle')}
      </Headline>
      <Button variant="secondary" iconName="download" iconOnRight onClick={handleDownloadReport}>
        {t('organizationOrders.downloadReportButton')}
      </Button>
    </>
  );
};

export default OrganizationOrders;
